import feedback from './feedback'
import store from '../store'
export default {
	feedback,
	getStore () {
		return store
	},
	fetch (request, options, payload) {
		var self = this
		return new Promise((resolve, reject) => {
			var mergedOptions = Object.assign({credentials: 'include'}, options)
			if (typeof mergedOptions.getparams === 'object') {
				request = request + '?' + self.queryBuild(mergedOptions.getparams)
			}
			if (typeof mergedOptions.postparams === 'object') {
				mergedOptions = Object.assign({body: self.buildFormData(mergedOptions.postparams)}, mergedOptions)
				// mergedOptions = Object.assign({body: JSON.stringify(mergedOptions.postparams)}, mergedOptions)
			}
			fetch(request, mergedOptions)
				.then(async r => {
					var data = await r.json()
					var outObj = {status: r.status, data: data}
					if (data) {
						return resolve(self.parseResponse(outObj))
					}
					return resolve(self.parseResponse({message: 'Server marked request as unsuccessful'}))
				})
				.catch(r => { console.error(r); return resolve(self.parseResponse(false)) })
		})
	},
	buildFormData (data) {
		var formDataInstance = new FormData()
		for (var key in data) {
			formDataInstance.append(key, data[key])
		}
		return formDataInstance
	},
	queryBuild (obj, prefix) {
		if (obj === null || typeof obj !== 'object') {
			return ''
		}

		var str = []
		var p
		for (p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + '[' + p + ']' : p
				var v = obj[p]
				str.push((v !== null && typeof v === 'object')
					? this.queryBuild(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent((v !== null) ? v : ''))
			}
		}
		return str.join('&')
	},
	parseResponse (r) {
		let RStatus = 0
		let RData = false
		let RIsSuccess = false
		let RErrorMessage = ''
		if (r === false) {
			RErrorMessage = 'Failed to fetch'
		} else if ('message' in r) {
			RErrorMessage = r.message
		} else if ('status' in r) {
			if (r.status === 200) {
				RStatus = r.status
				RData = r.data
				RIsSuccess = true
			} else {
				if ('data' in r) {
					if ('message' in r.data && 'status' in r.data) {
						RStatus = r.status
						RData = false
						RIsSuccess = false
						RErrorMessage = r.data.message
					} else {
						RErrorMessage = 'Response status is ' + r.status
					}
				} else {
					RErrorMessage = 'Response data is empty'
				}
			}
		}
		return {
			status: RStatus,
			data: RData,
			isSuccess: RIsSuccess,
			error: {
				// ok: false,
				message: RErrorMessage
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/index.js